/**
 * <card-comprar>: botão "Adicionar ao carrinho" dos cartões de produto nas coleções (snippets/card-comprar.liquid).
 * Põe o item no carrinho e avisa o tema pelo mesmo evento da página de produto (abre a gaveta).
 */
class CardComprar extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('button[data-variant]');
    if (!btn || this._ready) return;
    this._ready = true;
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      const label = btn.textContent;
      const items = [{ id: Number(btn.dataset.variant), quantity: 1 }];
      const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: ids.join(',') || undefined }),
        });
        const added = await r.json();
        if (!r.ok) throw new Error(added.description || 'add_failed');
        const cart = await (await fetch('/cart.js')).json();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'card-comprar', data: { source: 'card-comprar', itemCount: cart.item_count, sections: added.sections } } }));
        document.dispatchEvent(new CustomEvent('cart:add', { detail: { items, cart } }));
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
        btn.classList.add('is-done');
        btn.textContent = 'Adicionado';
        setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = label; }, 2500);
        if (window.track) window.track('card_added', { name: btn.dataset.name, quantity: 1 });
      } catch (err) {
        console.error('card-comprar: erro ao adicionar', err);
        btn.textContent = 'Tente de novo';
        setTimeout(() => (btn.textContent = label), 2500);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  }
}
if (!customElements.get('card-comprar')) customElements.define('card-comprar', CardComprar);
